module.exports = __webpack_public_path__ + "static/media/create-new-active.4c26a162.svg";